import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgHermes({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.657 11.226l.209-.851h-.463l-.209.85"
        fill="url(#Hermes_svg__paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 11.226l.209-.851H2l.731.85"
        fill="url(#Hermes_svg__paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.731 11.226L2 10.375v.269l.612.582"
        fill="url(#Hermes_svg__paint2_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.373 12.33l.224-.85h-.463l-.224.85"
        fill="url(#Hermes_svg__paint3_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.716 12.315l.224-.85H3.134l.747.85"
        fill="url(#Hermes_svg__paint4_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.88 12.315l-.746-.85v.253l.642.612"
        fill="url(#Hermes_svg__paint5_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.105 13.42l.223-.851h-.462l-.224.85"
        fill="url(#Hermes_svg__paint6_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.448 13.42l.209-.851H4.269l.746.85"
        fill="url(#Hermes_svg__paint7_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.03 13.42l-.746-.851v.239l.641.612"
        fill="url(#Hermes_svg__paint8_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.806 10.375c.075 0 .12.06.104.134 0 0-.656 2.553-.686 2.612l-.004.014c-.017.064-.048.182.064.21l-.015.09h-.672c-.09 0-.12-.075-.105-.135l.344-1.313h-.91l-.284 1.134-.004.014c-.017.064-.048.182.063.21l-.014.09h-.672c-.09 0-.12-.075-.105-.135 0 0 .582-2.209.672-2.612l.004-.013c.016-.065.047-.183-.064-.21l.015-.09h.672c.09 0 .12.06.104.134l-.253.985h.91s.18-.671.21-.806l.003-.013c.016-.065.047-.183-.064-.21l.015-.09h.672zm9.82 1.82c.06-.119.135-.432.135-.611.015-.433-.224-.627-.776-.627-.492 0-.776.105-1 .388-.224.284-.448.97-.448 1.418 0 .269.105.478.284.567.12.06.328.09.657.09.358 0 .582-.03.701-.09.09-.044.105-.09.164-.328l.09-.329h-.134c-.135.18-.224.24-.642.24-.194 0-.314-.016-.373-.06-.075-.045-.105-.12-.105-.21 0-.044 0-.104.015-.149l.045-.194h1.044c.224 0 .299-.014.344-.104zm-7.73 0c.06-.119.134-.432.134-.611.015-.433-.224-.627-.761-.612-.493 0-.777.104-1 .388-.224.284-.448.97-.448 1.418 0 .269.104.478.283.567.12.06.329.09.657.09.358 0 .582-.03.702-.09.09-.045.104-.09.164-.328l.09-.329h-.135c-.134.18-.224.24-.642.24-.194 0-.313-.016-.373-.06-.075-.045-.104-.12-.104-.21 0-.044 0-.104.015-.149l.044-.194h1.045c.224 0 .284-.03.329-.12zm10.014-.924l.075-.284H21c-.328 0-.522.09-.642.299-.104.179-.194.447-.194.641s.105.329.343.388l.448.12c.224.044.254.074.254.179 0 .06-.03.15-.075.194-.044.045-.12.075-.283.075h-.433c-.18 0-.269-.045-.299-.165h-.134l-.134.553c-.015.074.015.134.104.134h1.105c.253 0 .418-.075.552-.239.134-.179.224-.552.224-.791s-.09-.328-.403-.418l-.448-.134c-.12-.03-.15-.06-.15-.135 0-.074.016-.134.06-.179.045-.044.12-.06.314-.06h.448c.149 0 .224-.044.253-.178zm-10.403.388c0-.18-.104-.254-.343-.254-.313 0-.433.12-.537.507h.836c.03-.12.044-.179.044-.253zm7.732 0c0-.18-.105-.254-.344-.254-.313 0-.432.12-.537.507h.836c.03-.12.045-.179.045-.253zm-2.284-.687h-.328c-.164 0-.254.03-.358.194l-.12.194c.015-.194-.09-.388-.418-.388h-.298c-.234 0-.303.089-.36.161l-.013.018-.135.18.06-.21c.015-.06-.015-.134-.104-.134h-.598l-.03.09c.06.014.09.06.09.104 0 .03 0 .045-.015.09l-.522 2.03c-.015.06.015.134.104.134h.597l.015-.09c-.06-.015-.074-.06-.074-.09 0-.014 0-.044.015-.104 0 0 .343-1.268.343-1.284.075-.328.164-.358.343-.388h.12c.164 0 .223.105.194.224 0 .03-.403 1.612-.403 1.612-.015.06.015.135.104.135h.597l.015-.09c-.06-.015-.075-.06-.075-.09 0-.014 0-.044.015-.104l.344-1.284c.09-.328.164-.358.343-.388h.12c.178 0 .223.105.193.224 0 .015-.403 1.612-.403 1.612-.014.06.015.134.105.134h.597l.015-.089c-.06-.015-.075-.06-.075-.09 0-.014 0-.044.015-.104 0 0 .403-1.612.418-1.687.03-.194.03-.522-.433-.522zm-3.582.12c.075-.105.09-.105.239-.105l.477.015-.089.313c-.03.135-.09.18-.269.18h-.239c-.268 0-.343.06-.417.358l-.344 1.298c-.015.06-.015.09-.015.105 0 .03.015.074.075.09l-.015.089h-.597c-.09 0-.12-.075-.104-.135l.522-2.03c.015-.06.015-.089.015-.104 0-.03-.015-.075-.075-.09l.015-.089h.597c.09 0 .12.075.105.134l-.06.21.18-.24z"
        fill="#3C3C41"
      />
      <defs>
        <linearGradient
          id="Hermes_svg__paint0_linear"
          x1={6.958}
          y1={11.141}
          x2={6.718}
          y2={10.294}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#646469" />
          <stop offset={0.458} stopColor="#A9A9AE" />
          <stop offset={0.82} stopColor="#D9D9DE" />
          <stop offset={1} stopColor="#EBEBF0" />
        </linearGradient>
        <linearGradient
          id="Hermes_svg__paint1_linear"
          x1={8.171}
          y1={11.861}
          x2={8.278}
          y2={9.67}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F0F5" />
          <stop offset={0.062} stopColor="#CBE4EF" />
          <stop offset={0.198} stopColor="#96CDE4" />
          <stop offset={0.335} stopColor="#68B9DA" />
          <stop offset={0.472} stopColor="#42A9D1" />
          <stop offset={0.607} stopColor="#259CCB" />
          <stop offset={0.741} stopColor="#1193C7" />
          <stop offset={0.873} stopColor="#048EC4" />
          <stop offset={1} stopColor="#008CC3" />
        </linearGradient>
        <linearGradient
          id="Hermes_svg__paint2_linear"
          x1={1.321}
          y1={10.854}
          x2={2.455}
          y2={11.722}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F0F5" />
          <stop offset={0.092} stopColor="#DDECF3" />
          <stop offset={0.241} stopColor="#C5E1EE" />
          <stop offset={0.43} stopColor="#9DD0E5" />
          <stop offset={0.65} stopColor="#66B8D9" />
          <stop offset={0.895} stopColor="#209ACA" />
          <stop offset={1} stopColor="#008CC3" />
        </linearGradient>
        <linearGradient
          id="Hermes_svg__paint3_linear"
          x1={6.688}
          y1={12.236}
          x2={6.458}
          y2={11.386}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#646469" />
          <stop offset={0.458} stopColor="#A9A9AE" />
          <stop offset={0.82} stopColor="#D9D9DE" />
          <stop offset={1} stopColor="#EBEBF0" />
        </linearGradient>
        <linearGradient
          id="Hermes_svg__paint4_linear"
          x1={3.127}
          y1={12.321}
          x2={5.941}
          y2={12.321}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F0F5" />
          <stop offset={0.105} stopColor="#C0DEEA" />
          <stop offset={0.283} stopColor="#86C2DA" />
          <stop offset={0.454} stopColor="#56ABCC" />
          <stop offset={0.616} stopColor="#3199C2" />
          <stop offset={0.765} stopColor="#168DBA" />
          <stop offset={0.898} stopColor="#0685B6" />
          <stop offset={1} stopColor="#0082B4" />
        </linearGradient>
        <linearGradient
          id="Hermes_svg__paint5_linear"
          x1={2.598}
          y1={12.002}
          x2={3.648}
          y2={12.73}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F0F5" />
          <stop offset={0.16} stopColor="#C7E1EC" />
          <stop offset={0.512} stopColor="#77BBD6" />
          <stop offset={1} stopColor="#0082B4" />
        </linearGradient>
        <linearGradient
          id="Hermes_svg__paint6_linear"
          x1={6.41}
          y1={13.327}
          x2={6.18}
          y2={12.477}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#646469" />
          <stop offset={0.458} stopColor="#A9A9AE" />
          <stop offset={0.82} stopColor="#D9D9DE" />
          <stop offset={1} stopColor="#EBEBF0" />
        </linearGradient>
        <linearGradient
          id="Hermes_svg__paint7_linear"
          x1={3.993}
          y1={13.134}
          x2={5.081}
          y2={13.802}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F0F5" />
          <stop offset={0.104} stopColor="#C6E0EB" />
          <stop offset={0.348} stopColor="#80BDD6" />
          <stop offset={0.567} stopColor="#49A2C5" />
          <stop offset={0.755} stopColor="#218EB9" />
          <stop offset={0.903} stopColor="#0981B2" />
          <stop offset={0.994} stopColor="#007DAF" />
        </linearGradient>
        <linearGradient
          id="Hermes_svg__paint8_linear"
          x1={3.772}
          y1={13.137}
          x2={4.844}
          y2={13.907}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F0F5" />
          <stop offset={0.332} stopColor="#90C5DB" />
          <stop offset={0.657} stopColor="#439EC3" />
          <stop offset={0.886} stopColor="#1386B5" />
          <stop offset={1} stopColor="#007DAF" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SvgHermes
